import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["onClick", "disabled", "children", "trackingName", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as r, jsxs as u } from "react/jsx-runtime";
import g, { useCallback as N } from "react";
import { s as e } from "../FareInfographic.module-8nR033N7.js";
import { c as n } from "../clsx-OuTLNxxd.js";
import { Icon as x } from "../Icon/Icon.js";
import { i as v } from "../checks-C6AyTTQ0.js";
import { FareInfographicStep as F } from "./FareInfographicStep.js";
const _ = _ref => {
    let {
      onInclusionClick: a,
      expandable: o,
      isExpanded: s = !1,
      variant: i = "default",
      steps: l = []
    } = _ref;
    return /* @__PURE__ */r("div", {
      className: n(e.container, {
        [e.variantDefault]: i == "default",
        [e.variantFullHorizontal]: i == "full-horizontal",
        [e.variantAlwaysVertical]: i == "always-vertical",
        [e.expandable]: o,
        [e.static]: !o,
        [e.isExpanded]: s,
        [e.isCollapsed]: !s
      }),
      children: /* @__PURE__ */r("ul", {
        className: e.groups,
        children: l.map((t, p) => /* @__PURE__ */r(g.Fragment, {
          children: /* @__PURE__ */r(y, _objectSpread({
            index: p,
            isExpanded: i == "full-horizontal" || s,
            onInclusionClick: a
          }, t))
        }, t.id))
      })
    });
  },
  y = _ref2 => {
    let {
      id: a,
      icon: o,
      title: s,
      steps: i,
      isExpanded: l,
      onInclusionClick: t,
      index: p
    } = _ref2;
    const c = i.every(d => d.type == "disabled"),
      b = l,
      m = v(t),
      f = N(() => t == null ? void 0 : t(a), [a, t]);
    return /* @__PURE__ */u(g.Fragment, {
      children: [p != 0 && /* @__PURE__ */r("li", {
        className: n(e.separator, {
          [e.separatorDisabled]: c
        }),
        children: /* @__PURE__ */r("hr", {})
      }), /* @__PURE__ */u("li", {
        className: n(e.group, {
          [e.disabled]: c,
          [e.isShorex]: a == "shorex",
          [e.isPreCruise]: a == "pre-cruise",
          [e.isPostCruise]: a == "post-cruise"
        }),
        children: [/* @__PURE__ */r(h, {
          trackingName: s,
          onClick: m ? f : void 0,
          className: e.groupHeaderIcon,
          disabled: c,
          children: /* @__PURE__ */r(x, {
            name: o,
            size: void 0,
            padding: !1
          })
        }), /* @__PURE__ */r(h, {
          trackingName: s,
          onClick: m ? f : void 0,
          className: n(e.groupHeader, {
            [e.groupHeaderUnderline]: m && !c
          }),
          disabled: c,
          children: s
        }), b && /* @__PURE__ */r("ul", {
          className: e.steps,
          children: i.map(d => /* @__PURE__ */r(F, _objectSpread({}, d), d.id))
        })]
      }, a)]
    });
  },
  h = _ref3 => {
    let {
        onClick: a,
        disabled: o = !1,
        children: s,
        trackingName: i,
        className: l
      } = _ref3,
      t = _objectWithoutProperties(_ref3, _excluded);
    return v(a) && !o ? /* @__PURE__ */r("button", _objectSpread(_objectSpread({
      onClick: a,
      className: l,
      "data-content-piece": o ? void 0 : "infographic_inclusion_".concat(i)
    }, t), {}, {
      children: s
    })) : /* @__PURE__ */r("div", {
      className: l,
      children: s
    });
  };
export { _ as FareInfographic };